module.exports = __webpack_public_path__ + "img/logo_white.3f126f95.svg";